export const LoginAdalName = 'loginAdalComponent';
